import { render, staticRenderFns } from "./StaffDashboard.vue?vue&type=template&id=26250c4c&"
import script from "./StaffDashboard.vue?vue&type=script&lang=ts&"
export * from "./StaffDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports